import { Link } from "react-router-dom";

import { Logo } from "../../components/Logo";
import { SiteFooter } from "../../components/SiteFooter";

export function Verified() {
  return (
    <>
      <div className="top-line" />
      <div className="page">
        <div className="card">
          <Logo />
          <div className="icon-circle" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2.5}
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>
          <h1>Email verified!</h1>
          <p className="sub">
            Your email has been verified. An administrator will review your request shortly —
            you&apos;ll be able to sign in once your account is approved.
          </p>
          <Link to="/login" className="btn btn--primary" style={{ marginTop: 28 }}>
            Sign in
          </Link>
        </div>
      </div>
      <SiteFooter />
    </>
  );
}
